<template>
<vs-card class="cardx">
  <div class="box_list_div1">
    <div class="ps_box_btnAdd">
      <vs-button @click="createKey()" color="darkgreen" type="border" icon="add"> Crear Nueva Llave De Registro </vs-button>
    </div>
  </div>
  <div v-if="showA" class="box_list_div2">
    <vs-table  :max-items="$store.state.pagination" pagination search :data="box">
      <template slot="thead">
      <vs-th sort-key="uuid">
          UUID
      </vs-th>
      <vs-th sort-key="register_key">
          Llave De Activación De Registro
      </vs-th>
      <vs-th sort-key="status">
          Estado
      </vs-th>
      </template>

      <template slot-scope="{data}">
      <vs-tr :style="data[indextr].status === 0? 'background-color: rgb(0 255 37 / 10%);':data[indextr].status === 1?'background-color: rgb(255 0 0 / 10%)':'background-color: none'" :key="indextr" v-for="(tr, indextr) in data" >
          <vs-td :data="data[indextr].uuid">
          {{data[indextr].uuid}}
          </vs-td>
          <vs-td :data="data[indextr].register_key">
          {{data[indextr].register_key}}
          </vs-td>
          <vs-td v-if="data[indextr].status === 0" :data="data[indextr].status">
          Disponible
          </vs-td>
          <vs-td v-if="data[indextr].status === 1" :data="data[indextr].status">
          Usado
          </vs-td>
      </vs-tr>
      </template>
    </vs-table>
  </div>
  <div v-if="!showA" class="box_list_div3">
    <vs-alert class="ps_alert_register" title="Information" color="rgb(231, 154, 23)">
            No Hay Datos Para Mostrar.
    </vs-alert>
  </div>
  <div>
    <Modal :show="showModal" @close="showModal = false">
      <template #body>
        <RegisterKey></RegisterKey>
      </template>
    </Modal>
  </div>
</vs-card>
</template>
<script>
import axios from 'axios'
import Modal from './components/utils/Modal.vue';
import RegisterKey from './components/box/RegisterKey.vue';

export default {
    name: "boxRegiter",
    props:{
    },
    components: {
    Modal,
    RegisterKey
},
    data:()=>({
    showA: false,
    box: [],
    showModal: false,
  }),
  methods: {
    scrollInto(elementId) {
      const section = document.querySelector(`#${elementId}`);
      section.scrollIntoView({
        behavior: 'smooth'
      });
    },
    boxRegisterList(){
      const url_api =  this.$store.state.url_api
      axios.get(url_api + 'api/boxRegisterList').then(response => {
        this.box = response.data
        if(response.data.isok === false){
          this.showA = false
        }
        else{
          this.showA = true
        }
      })
      .catch((error) => {
        console.error(error)
      })
    },
    createKey(){
      this.showModal = true
    }
  },
  mounted(){
  this.boxRegisterList()
  },
  watch: {
    showModal: function(val){
      this.boxRegisterList()
    }
  }
}
</script>
<style>
.ps_alert_box_list{
  text-align: center;
}
  .box_list_div1{
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    width: auto;
    height: 50px;
  }

  .ps_box_btnAdd{
    float: right;
    width: auto;
  }

  .box_list_div2{
    margin-top: 20px;
    width: auto;
    height: 200px;
  }
  .box_list_div3{
    text-align:center;
  }
  .ps_alert_register{
    margin:0px auto;
    margin-top: 10px;
    width: max-content;
    min-width: 300px;
  }
  .vs-table--search-input{
    border: 0.5px solid rgb(43 43 43 / 49%);
    border-radius: 8px;
  }
</style>